module.exports = __webpack_public_path__ + "static/media/home.e32b1a37.svg";